import { Alert, DatePicker, Form, Input, Space, Typography } from "antd";
import { useEffect, useState } from "react";

import { getErrors } from "../../api/dashboard.api";
import Card from "../../components/ui/Card";
import Spinner from "../../components/ui/Spinner";
import Table from "../../components/ui/Table";
import { formatDate, formatShortId } from "../../utils/formatters";

const ErrorsPage = () => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [filters, setFilters] = useState({
    error_type: "",
    start_date: "",
    end_date: "",
  });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  useEffect(() => {
    const run = async () => {
      try {
        setLoading(true);
        setError(null);
        const { data: response } = await getErrors({
          error_type: filters.error_type || undefined,
          start_date: filters.start_date || undefined,
          end_date: filters.end_date || undefined,
          page,
          per_page: pageSize,
        });
        setData(response);
      } catch (_error) {
        setError("Unable to load errors right now.");
      } finally {
        setLoading(false);
      }
    };

    void run();
  }, [filters, page, pageSize]);

  return (
    <div className="page-stack">
      <Typography.Title level={2}>Errors</Typography.Title>
      {error ? <Alert type="error" showIcon message={error} /> : null}
      <Card>
        <Form layout="inline">
          <Form.Item label="Error type">
            <Input
              placeholder="ValidationError"
              value={filters.error_type}
              onChange={event => {
                setPage(1);
                setFilters(current => ({
                  ...current,
                  error_type: event.target.value,
                }));
              }}
            />
          </Form.Item>
          <Form.Item label="Start">
            <DatePicker
              onChange={value => {
                setPage(1);
                setFilters(current => ({
                  ...current,
                  start_date: value ? value.startOf("day").toISOString() : "",
                }));
              }}
            />
          </Form.Item>
          <Form.Item label="End">
            <DatePicker
              onChange={value => {
                setPage(1);
                setFilters(current => ({
                  ...current,
                  end_date: value ? value.endOf("day").toISOString() : "",
                }));
              }}
            />
          </Form.Item>
        </Form>
      </Card>
      {loading && !data ? <Spinner /> : null}
      {data ? (
        <Card>
          <Table
            dataSource={data.errors}
            pagination={{
              total: data.total ?? 0,
              current: page,
              pageSize,
              showSizeChanger: true,
              pageSizeOptions: ["20", "50", "100"],
              onChange: (newPage, newPageSize) => {
                setPage(newPage);
                setPageSize(newPageSize);
              },
            }}
            expandable={{
              expandedRowRender: (record: any) => (
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Typography.Text strong>Stack trace</Typography.Text>
                  <pre className="stack-trace">
                    {record.stack_trace || "No stack trace available"}
                  </pre>
                </Space>
              ),
            }}
            columns={[
              {
                title: "Timestamp",
                dataIndex: "timestamp",
                render: (value: string) => formatDate(value),
              },
              { title: "Type", dataIndex: "error_type" },
              { title: "Message", dataIndex: "error_message" },
              {
                title: "Chat Log",
                dataIndex: "chat_log_id",
                render: (value: string | null) => formatShortId(value),
              },
            ]}
          />
        </Card>
      ) : null}
    </div>
  );
};

export default ErrorsPage;
